import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CompanyResponse } from '../models/empresa.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface EmpresaDrawerOptions {
  empresaId?: number;
  contactId?: number;
  contactName?: string;
}

@Injectable({ providedIn: 'root' })
export class EmpresaDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: EmpresaDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly empresaSaved$$ = new Subject<CompanyResponse>();

  readonly state = this.state$.asObservable();
  readonly empresaSaved$ = this.empresaSaved$$.asObservable();

  open(options: EmpresaDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(empresa: CompanyResponse): void {
    this.empresaSaved$$.next(empresa);
  }
}
